/** Spanish rounding prompts (ADR 0051 part 3). See the English module for why each clause is written whole. */
export const roundClauses: Record<number, string> = {
    [-1]: 'al décimo más cercano',
    0: 'al entero más cercano',
    1: 'a la decena más cercana',
    2: 'a la centena más cercana',
    3: 'al millar más cercano',
};

export const roundingPrompts = {
    round: (value: string, clause: string) => `Redondea ${value} ${clause}.`,
};
